module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-7days-10eb61b74cda53f79dc1ad8c0d3d70c2.jpg";